﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

import { JssClass } from "~base/Styling";
import { getSize } from "~base/Components/Layout/JssSpacing";

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

//-------------------------------------------------------------------------------------
// Customizations
//-------------------------------------------------------------------------------------

export interface CustomStyles {
    header?: JssClass;
    bottom?: JssClass;
    radioPadding?: JssClass;
}

export const defaultStyling = {
    header: {
        padding: `25px ${25 + getSize("HalfMedium")}px 0px ${25 + getSize("HalfMedium")}px`,
    },
    bottom: {
        display: "flex",
        flexDirection: "row-reverse",
        alignItems: "center",
        justifyContent: "space-between",
    },
};

export interface NotFoundPageCustomizations {
    customStyles?: CustomStyles;
}

export const NotFoundPageDefaultCustomization = {
    customStyles: defaultStyling,
} as NotFoundPageCustomizations;
